import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close, Search as SearchIcon } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Input } from "@air/primitive-input";
import { Tooltip } from "@air/primitive-tooltip";
import classNames from "classnames";
import debounce from "lodash/debounce";
import { memo, useCallback, useState } from "react";
/**
 * @description A SearchBar component that does not use ComboBox
 */ export const SimpleSearchBar = /*#__PURE__*/ memo((param)=>{
    let { onSearchTermChange, placeholder, name, hideCloseButton = false } = param;
    const [value, setValue] = useState("");
    // eslint complains about passing inline function, but only this version works with debounce
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedOnSearchChange = useCallback(debounce(onSearchTermChange, 600), [
        onSearchTermChange
    ]);
    const hasCloseButton = !!value && !hideCloseButton;
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ _jsx(SearchIcon, {
                className: "absolute left-3 top-3 size-4 text-10 text-grey-9 [&>path]:stroke-[2.5px]"
            }),
            /*#__PURE__*/ _jsx(Input, {
                "data-1p-ignore": true,
                className: classNames("w-full pl-9", hasCloseButton ? "pr-9" : ""),
                size: "large",
                value: value,
                onChange: (evt)=>{
                    setValue(evt.target.value);
                    debouncedOnSearchChange(evt.target.value);
                },
                placeholder: placeholder,
                name: name,
                "data-testid": "SIMPLE_SEARCH_BAR_INPUT"
            }),
            hasCloseButton && /*#__PURE__*/ _jsx(Tooltip, {
                label: "Clear search",
                children: /*#__PURE__*/ _jsx(IconButton, {
                    className: "absolute right-3 top-3",
                    appearance: "ghost",
                    color: "grey",
                    label: "Clear search",
                    icon: Close,
                    onClick: ()=>{
                        setValue("");
                        onSearchTermChange("");
                    },
                    size: "extra-small"
                })
            })
        ]
    });
});
SimpleSearchBar.displayName = "SimpleSearchBar";
